import React, { useState } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const Timeline = () => {
    const [expandedEvent, setExpandedEvent] = useState(null);

    // Sample events data - this would come from backend in real implementation
    const events = [
        {
            id: 4,
            title: "Community Service - Ramadan Iftar",
            date: "2025-03-24",
            time: "18:00 - 20:00",
            location: "Dar Maram, Ariana",
            description: "Community service initiative organizing iftar meals for children at Dar Maram during Ramadan. Demonstrates how technology professionals can give back to society and make a positive social impact.",
            volunteers: 25,
            children_served: 50,
            status: "completed"
        },
        {
            id: 5,
            title: "Robotics  Workshop",
            date: "2024-10-20",
            time: "13:30 - 17:00",
            location: "ISI Ariana - Lab B205",
            description: "Biginner workshop on robotics and micro controllers. Covers Esp32 , C programming,  and practical.",
            trainer: "Ayoub Sandi,Achref Habibi",
            participants: 35,
            status: "completed"
        },
        {
            id: 1,
            title: "Flutter & Mobile Development Workshop",
            date: "2024-01-15",
            time: "09:00 - 17:00",
            location: "ISI Ariana - Room A101",
            description: "Comprehensive hands-on workshop covering Flutter development from basics to advanced concepts. Led by industry expert Hamed, participants will build real mobile applications and learn best practices for cross-platform development.",
            trainer: "Hamed Ben Ali",
            participants: 45,
            status: "completed"
        },
        {
            id: 2,
            title: "Play4Hope Cup Competition",
            date: "2024-02-20",
            time: "10:00 - 18:00",
            location: "ISI Ariana - Main Hall",
            description: "Annual coding competition bringing together the brightest minds from ISI and beyond. Teams compete in algorithmic challenges, web development, and mobile app creation. Prizes include internships and tech gadgets.",
            participants: 120,
            prizes: "1st: MacBook Pro, 2nd: iPad Pro, 3rd: AirPods Pro",
            status: "completed"
        },
        {
            id: 3,
            title: "Land It! Career Fair",
            date: "2024-03-10",
            time: "09:00 - 16:00",
            location: "ISI Ariana - Conference Center",
            description: "Career fair connecting students with top tech companies. Features presentations from industry leaders, resume workshops, mock interviews, and direct recruitment opportunities.",
            companies: ["Google", "Microsoft", "Facebook", "Amazon", "Local Startups"],
            participants: 200,
            status: "completed"
        },
        
        
        {
            id: 6,
            title: "Creative Lab Annual Conference",
            date: "2024-05-20",
            time: "08:00 - 18:00",
            location: "ISI Ariana - Main Auditorium",
            description: "Annual conference showcasing student projects, industry insights, and networking opportunities. Features keynote speakers, project exhibitions, and career development sessions.",
            speakers: ["Tech Industry Leaders", "ISI Alumni", "Startup Founders"],
            participants: 300,
            status: "upcoming"
        }
    ];

    const toggleEvent = (eventId) => {
        setExpandedEvent(expandedEvent === eventId ? null : eventId);
    };

    const getStatusColor = (status) => {
        switch (status) {
            case 'completed': return '#28a745';
            case 'upcoming': return '#007bff';
            case 'cancelled': return '#dc3545';
            default: return '#6c757d';
        }
    };

    const getStatusText = (status) => {
        switch (status) {
            case 'completed': return 'Completed';
            case 'upcoming': return 'Upcoming';
            case 'cancelled': return 'Cancelled';
            default: return 'Unknown';
        }
    };

    return (
        <div>
            <Header />
            <div className="page-heading header-text">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <h1>Event Timeline</h1>
                            <span>Explore our past and upcoming events</span>
                        </div>
                    </div>
                </div>
            </div>

            <div className="callback-form contact-us">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="section-heading">
                                <h2>Our <em>Event History</em></h2>
                                <span>Discover the impact we've made through our community events</span>
                            </div>
                        </div>
                    </div>

                    <div className="timeline-container" style={{ position: 'relative', padding: '20px 0' }}>
                        {events.map((event, index) => (
                            <div key={event.id} className="timeline-item" style={{ 
                                marginBottom: '40px', 
                                position: 'relative',
                                paddingLeft: '60px'
                            }}>
                                {/* Timeline dot */}
                                <div style={{
                                    position: 'absolute',
                                    left: '20px',
                                    top: '20px',
                                    width: '20px',
                                    height: '20px',
                                    borderRadius: '50%',
                                    backgroundColor: getStatusColor(event.status),
                                    border: '4px solid #fff',
                                    boxShadow: '0 0 0 4px #F4276F',
                                    zIndex: 2
                                }}></div>

                                {/* Timeline line */}
                                {index < events.length - 1 && (
                                    <div style={{
                                        position: 'absolute',
                                        left: '29px',
                                        top: '40px',
                                        width: '2px',
                                        height: '60px',
                                        backgroundColor: '#F4276F',
                                        zIndex: 1
                                    }}></div>
                                )}

                                {/* Event card */}
                                <div style={{
                                    backgroundColor: '#fff',
                                    borderRadius: '10px',
                                    padding: '20px',
                                    boxShadow: '0 4px 15px rgba(0,0,0,0.1)',
                                    border: '1px solid #eee',
                                    cursor: 'pointer',
                                    transition: 'all 0.3s ease'
                                }}
                                onClick={() => toggleEvent(event.id)}
                                onMouseEnter={(e) => e.target.style.transform = 'translateY(-5px)'}
                                onMouseLeave={(e) => e.target.style.transform = 'translateY(0)'}
                                >
                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '15px' }}>
                                        <div>
                                            <h3 style={{ color: '#1e1e1e', marginBottom: '5px', fontSize: '20px' }}>{event.title}</h3>
                                            <p style={{ color: '#666', margin: '0', fontSize: '14px' }}>
                                                📅 {new Date(event.date).toLocaleDateString('en-US', { 
                                                    year: 'numeric', 
                                                    month: 'long', 
                                                    day: 'numeric' 
                                                })} • 🕒 {event.time} • 📍 {event.location}
                                            </p>
                                        </div>
                                        <span style={{
                                            backgroundColor: getStatusColor(event.status),
                                            color: '#fff',
                                            padding: '5px 12px',
                                            borderRadius: '20px',
                                            fontSize: '12px',
                                            fontWeight: 'bold'
                                        }}>
                                            {getStatusText(event.status)}
                                        </span>
                                    </div>

                                    <div style={{ display: 'flex', alignItems: 'center', marginBottom: '15px' }}>
                                        
                                        <p style={{ color: '#666', margin: '0', fontSize: '14px', lineHeight: '1.4' }}>
                                            {event.description.substring(0, 150)}...
                                        </p>
                                    </div>

                                    {/* Expandable content */}
                                    {expandedEvent === event.id && (
                                        <div style={{ 
                                            marginTop: '20px', 
                                            padding: '20px', 
                                            backgroundColor: '#f8f9fa', 
                                            borderRadius: '8px',
                                            border: '1px solid #e9ecef'
                                        }}>
                                            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px', marginBottom: '20px' }}>
                                                <div>
                                                    <h4 style={{ color: '#F4276F', marginBottom: '10px' }}>Event Details</h4>
                                                    <p><strong>Date:</strong> {new Date(event.date).toLocaleDateString('en-US', { 
                                                        weekday: 'long',
                                                        year: 'numeric', 
                                                        month: 'long', 
                                                        day: 'numeric' 
                                                    })}</p>
                                                    <p><strong>Time:</strong> {event.time}</p>
                                                    <p><strong>Location:</strong> {event.location}</p>
                                                    {event.trainer && <p><strong>Trainer:</strong> {event.trainer}</p>}
                                                    {event.participants && <p><strong>Participants:</strong> {event.participants}</p>}
                                                </div>
                                                <div>
                                                    <h4 style={{ color: '#F4276F', marginBottom: '10px' }}>Additional Info</h4>
                                                    {event.companies && (
                                                        <p><strong>Participating Companies:</strong> {event.companies.join(', ')}</p>
                                                    )}
                                                    {event.prizes && <p><strong>Prizes:</strong> {event.prizes}</p>}
                                                    {event.volunteers && <p><strong>Volunteers:</strong> {event.volunteers}</p>}
                                                    {event.children_served && <p><strong>Children Served:</strong> {event.children_served}</p>}
                                                    {event.speakers && (
                                                        <p><strong>Keynote Speakers:</strong> {event.speakers.join(', ')}</p>
                                                    )}
                                                </div>
                                            </div>
                                            <div>
                                                <h4 style={{ color: '#F4276F', marginBottom: '10px' }}>Full Description</h4>
                                                <p style={{ lineHeight: '1.6', color: '#666' }}>{event.description}</p>
                                            </div>
                                        </div>
                                    )}

                                    <div style={{ textAlign: 'right', marginTop: '15px' }}>
                                        <span style={{ 
                                            color: '#F4276F', 
                                            fontSize: '14px', 
                                            fontWeight: 'bold',
                                            cursor: 'pointer'
                                        }}>
                                            {expandedEvent === event.id ? 'Show Less ▲' : 'Learn More ▼'}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default Timeline;
